import React from "react";
import { Link } from "react-router-dom";
import { Calculator, MessageCircle, Sparkles, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { whatsappHref } from "@/lib/settings";

export const HeroSection = ({ home, whatsappNumber }) => (
  <section className="relative overflow-hidden" data-testid="hero-section">
    <div className="absolute inset-0 gradient-primary-soft" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20 lg:py-28 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-6 space-y-7">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/70 border border-brand-100 px-4 py-1.5 text-xs font-semibold text-brand-700">
          <Sparkles className="h-3.5 w-3.5" /> Ölçüye Özel Mobilya Tasarımı
        </span>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.05] text-ink-900">
          <span className="gradient-text">Hayalinizdeki Mobilyayı</span> Ölçünüze Özel Tasarlayın
        </h1>
        <p className="text-lg text-ink-500 leading-relaxed max-w-xl">
          {home.hero_subtitle || "Mutfaktan gardıroba, TV ünitesinden kiler dolabına, atölyemizde milimetrik hassasiyetle üretilen mobilyalarınızı dakikalar içinde fiyatlandırın."}
        </p>
        <div className="flex flex-wrap gap-3">
          <Link to="/fiyat-hesaplama">
            <Button data-testid="hero-price-btn" size="lg" className="gradient-primary text-white rounded-full px-7 py-6 text-sm font-bold uppercase tracking-wide hover:brightness-110 hover:-translate-y-0.5 transition-transform brand-shadow">
              <Calculator className="h-4 w-4 mr-2" /> Fiyat Hesapla
            </Button>
          </Link>
          <a
            data-testid="hero-whatsapp-btn"
            href={whatsappHref(whatsappNumber, "Merhaba, mobilya için bilgi almak istiyorum.")}
            target="_blank"
            rel="noreferrer"
          >
            <Button size="lg" variant="outline" className="rounded-full border-2 border-ink-900 text-ink-900 px-7 py-6 text-sm font-bold uppercase hover:bg-ink-900 hover:text-white transition-colors">
              <MessageCircle className="h-4 w-4 mr-2" /> WhatsApp ile İletişim
            </Button>
          </a>
        </div>
        <div className="flex flex-wrap items-center gap-6 pt-4 text-sm text-ink-500">
          <div className="flex items-center gap-2"><Star className="h-4 w-4 fill-brand-500 text-brand-500" /> 5.0 ortalama</div>
          <div className="hidden sm:block h-4 w-px bg-ink-100" />
          <div>2 Yıl Garanti · Hızlı Teslimat</div>
        </div>
      </div>
      <div className="lg:col-span-6 relative">
        <div className="relative aspect-[4/3] rounded-3xl overflow-hidden brand-shadow-lg">
          <img
            src={home.hero_image || "https://images.unsplash.com/photo-1714860534425-7ce04e013dec"}
            alt="Modern mutfak"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
          <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between">
            <div className="rounded-2xl bg-white/95 backdrop-blur-md px-4 py-3 shadow-lg">
              <div className="text-[10px] font-bold uppercase tracking-widest text-brand-600">Yeni Proje</div>
              <div className="text-sm font-semibold text-ink-900">Modern Siyah Mutfak</div>
            </div>
            <div className="hidden sm:flex items-center gap-2 rounded-full bg-white/95 backdrop-blur-md px-4 py-2 shadow-lg">
              <span className="h-2 w-2 rounded-full bg-brand-500 animate-pulse" />
              <span className="text-xs font-semibold text-ink-700">Anlık Fiyat</span>
            </div>
          </div>
        </div>
        <div className="hidden lg:block absolute -top-6 -left-6 h-28 w-28 rounded-full gradient-primary opacity-90" />
        <div className="hidden lg:block absolute -bottom-8 -right-6 h-40 w-40 rounded-3xl bg-ink-900" />
      </div>
    </div>
  </section>
);
